import * as ActionTypes from '../constants/actionTypes'
import { apiClient } from '../lib';

import store from '../store'

export const reset = (params = {}) => {
  return apiClient.organizations.availabilities.reset(params)
}
